import React from 'react';
import classes from './KeyValueLabel.module.scss';
import PropTypes from 'prop-types';

export default function KeyValueLabel({ label, value, extraStyles, oneLine = false }) {
  return oneLine ? (
    <p>
      <span className={classes.key}>{label}</span>&nbsp;
      <span className={classes.value}>{value}</span>
    </p>
  ) : (
    <div className={`${classes.wrapper} ${extraStyles}`}>
      <span className={classes.key}>{label}</span>
      <span className={classes.value}>{value}</span>
    </div>
  );
}

KeyValueLabel.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  extraStyles: PropTypes.object
};
